<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<fe-header style="z-index: 1100"></fe-header>
<main>
    <fe-progress-bar
        [status]="'extras'"
        class="d-none d-md-block"
        #progressBarDesktop
        *ngIf="!breakpoint.isMobile()"
    ></fe-progress-bar>
    <fe-progress-bar-mobile
        *ngIf="breakpoint.isMobile()"
        class="d-block d-md-none"
        [statusProgress]="'extras'"
    ></fe-progress-bar-mobile>
    <section
        [style.marginTop.px]="progressBarDesktop?.martinTopContainer"
        class="main container-fluid"
    >
        <div class="main__wrapper container-xl">
            <!-- <div class="main__wrapper__header">
                <h1 class="title">
                    {{
                        'fe_details_step3_main_wrapper_header_title' | translate
                    }}
                </h1>
                <button
                    *ngIf="currentReservation.current.origin === 'NAT'"
                    class="btn__header"
                    (click)="emptyNext()"
                    [disabled]="loadingBtnContinue"
                    [ngClass]="{
                        loading: loadingBtnContinue
                    }"
                >
                    {{
                        'fe_details_step3_main_wrapper_header_btn_header'
                            | translate
                    }}
                </button>
            </div> -->
            <fe-upgrade-promotion
                *ngIf="reservation.isUpgradePromotion"
                [vehicle]="reservation.vehicle"
                [vehicleUpgradePromotion]="
                    reservation.upgradeCatergoryPromotion
                "
            ></fe-upgrade-promotion>
            <ng-container
                *ngIf="
                    !reservation.isUpdateCategory &&
                    currentReservation.current.origin === 'NAT'
                "
            >
                <ng-container *ngIf="isLoadingUpdateSummary">
                    <div class="row p-4 placeholder-wave">
                        <div class="col-12">
                            <div
                                class="placeholder"
                                style="min-height: 25vh"
                            ></div>
                        </div>
                    </div>
                </ng-container>

                <ng-container
                    *ngIf="
                        !isLoadingUpdateSummary &&
                        (updateSummary?.priceDifference ?? 0) > 0
                    "
                >
                    <fe-upgrade-category
                        [updateSummary]="updateSummary"
                        [loadingPrice]="loadingPrice"
                    ></fe-upgrade-category>
                </ng-container>
            </ng-container>

            <div class="main__wrapper_body">
                <ng-container
                    *ngIf="responseInsurance; else noInsurancePlaceholder"
                >
                    <fe-protection-level
                        [currency]="currency"
                        [insurances]="responseInsurance"
                        [rentDays]="rentDays"
                        [freeDays]="freeDays"
                        [disabled]="loadingBtnContinue"
                        (activeInsurancesChange)="
                            updateActiveInsurances($event)
                        "
                    ></fe-protection-level>
                </ng-container>
                <ng-template #noInsurancePlaceholder>
                    <div class="protection__title d-flex flex-column ps-3">
                        <h2 class="title">
                            {{
                                'fe_details_step3_protection_level_protection_title_title'
                                    | translate
                            }}
                        </h2>
                        <h3 class="subtitle">
                            {{
                                'fe_details_step3_protection_level_protection_title_subtitle'
                                    | translate
                            }}
                        </h3>
                    </div>
                    <div
                        class="skeleton__grid placeholder-wave"
                        *ngIf="
                            currentReservation.current.origin === 'INT';
                            else noInsurancePlaceholderNat
                        "
                    >
                        <div class="skeleton__card" *ngFor="let i of [1, 2, 3]">
                            <div class="skeleton__card__main">
                                <div class="skeleton__card__name">
                                    <span
                                        class="placeholder skeleton__icon"
                                    ></span>
                                    <span
                                        class="placeholder skeleton__title"
                                    ></span>
                                </div>
                                <span class="placeholder skeleton__line"></span>
                                <span
                                    class="placeholder skeleton__line skeleton__line--short"
                                ></span>
                                <span
                                    class="placeholder skeleton__details"
                                ></span>
                            </div>
                            <div class="skeleton__card__footer">
                                <span class="placeholder skeleton__price"></span>
                                <span class="placeholder skeleton__add"></span>
                            </div>
                        </div>
                    </div>
                    <ng-template #noInsurancePlaceholderNat>
                        <div
                            class="skeleton__grid skeleton__grid--protection placeholder-wave"
                        >
                            <div
                                class="skeleton__card"
                                *ngFor="let i of [1, 2, 3]"
                            >
                                <div class="skeleton__card__head">
                                    <div class="skeleton__card__name">
                                        <span
                                            class="placeholder skeleton__icon"
                                        ></span>
                                        <span
                                            class="placeholder skeleton__title"
                                        ></span>
                                    </div>
                                    <span
                                        class="placeholder skeleton__tagline"
                                    ></span>
                                    <span
                                        class="placeholder skeleton__price"
                                    ></span>
                                    <span
                                        class="placeholder skeleton__summary"
                                    ></span>
                                </div>
                                <div class="skeleton__card__features">
                                    <span
                                        class="placeholder skeleton__feature"
                                        *ngFor="let f of [1, 2, 3, 4, 5]"
                                    ></span>
                                </div>
                                <div class="skeleton__card__footer">
                                    <span
                                        class="placeholder skeleton__cta"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-template>
                <div #extrasSection>
                    <ng-container
                        *ngIf="responseProduct; else noProductPlaceholder"
                    >
                        <fe-travel-upgrades
                            [currency]="currency"
                            [products]="responseProduct"
                            (activeProductsChange)="updateActiveProducts($event)"
                        ></fe-travel-upgrades>
                    </ng-container>
                </div>
                <ng-template #noProductPlaceholder>
                    <div class="travel__title ps-3">
                        <h2 class="title">
                            {{
                                'fe_details_step3_travel_upgrades_title'
                                    | translate
                            }}
                        </h2>
                    </div>
                    <div class="skeleton__grid placeholder-wave">
                        <div class="skeleton__card" *ngFor="let i of [1, 2, 3]">
                            <div class="skeleton__card__main">
                                <div class="skeleton__card__name">
                                    <span
                                        class="placeholder skeleton__icon"
                                    ></span>
                                    <span
                                        class="placeholder skeleton__title"
                                    ></span>
                                </div>
                                <span class="placeholder skeleton__line"></span>
                                <span
                                    class="placeholder skeleton__line skeleton__line--short"
                                ></span>
                                <span
                                    class="placeholder skeleton__details"
                                ></span>
                            </div>
                            <div class="skeleton__card__footer">
                                <span class="placeholder skeleton__price"></span>
                                <span class="placeholder skeleton__add"></span>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
            <div class="main__wrapper__footer">
                <p class="footer__hint" *ngIf="isMissingInsurance">
                    {{
                        'fe_details_step3_main_wrapper_footer_no_coverage_hint'
                            | translate
                    }}
                </p>
                <fe-button
                    (onClick)="handleFooterClick()"
                    [loading]="loadingBtnContinue"
                    class="mob-width"
                    [btnClass]="'justify-content-center'"
                >
                    {{ footerButtonKey | translate }}
                </fe-button>
            </div>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
